<template>
	<v-card>
		<v-card-title>
			Azione in massa: Prima Scadenza Fattura Esiti Definitivi
		</v-card-title>
		
		<v-card-text>
			<v-row>
				<v-col>
					<v-form ref="formAssegnaInMassaDataScadenzaSaldoEsitiDefinitivi">
						<v-menu
							v-model="menuDataScadenzaSaldoEsitiDefinitivi"
							:close-on-content-click="false"
							max-width="290"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									:value="formatDateToItaly(dataScadenzaSaldoEsitiDefinitivi)"
									label="Prima Scadenza Fattura Esiti Definitivi"
									outlined
									dense
									readonly
									v-bind="attrs"
									v-on="on"
									clearable
									@click:clear="dataScadenzaSaldoEsitiDefinitivi = null"
									class="mt-1"
									:rules="[mixin_rules.required]"
								></v-text-field>
							</template>
							<v-date-picker
								:value="dataScadenzaSaldoEsitiDefinitivi"
								@input="dataScadenzaSaldoEsitiDefinitivi = $event !== '' ? $event : null"
								@change="menuDataScadenzaSaldoEsitiDefinitivi = false"
								first-day-of-week="1"
							></v-date-picker>
						</v-menu>
					</v-form>
				</v-col>
			</v-row>
		</v-card-text>
		
		<!--<v-divider></v-divider>-->
		
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				class="black--text"
				@click="$emit('close')"
			>
				Chiudi
			</v-btn>
			<v-btn
				color="secondary"
				@click="assegnaInMassaDataScadenzaSaldoEsitiDefinitivi()"
				:loading="isLoadingAssegnaInMassaDataScadenzaSaldoEsitiDefinitivi"
			>
				Esegui
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		contrattiDiServizioIds: {
			default: []
		}
	},
	data() {
		return {
			menuDataScadenzaSaldoEsitiDefinitivi: false,
			dataScadenzaSaldoEsitiDefinitivi: null,
			isLoadingAssegnaInMassaDataScadenzaSaldoEsitiDefinitivi: false
		}
	},
	
	methods: {
		assegnaInMassaDataScadenzaSaldoEsitiDefinitivi() {
			if (!this.$refs.formAssegnaInMassaDataScadenzaSaldoEsitiDefinitivi.validate()) return;
			
			this.isLoadingAssegnaInMassaDataScadenzaSaldoEsitiDefinitivi = true;
			axios.post('/api/contratti-di-servizio/assegna-in-massa-data-scadenza-saldo-esiti-definitivi', {
				data_scadenza_saldo_esiti_definitivi: this.dataScadenzaSaldoEsitiDefinitivi,
				contratti_di_servizio_ids: this.contrattiDiServizioIds
			})
				.then(() => {
					this.$emit('close');
					this.$emit('done');
				})
				.finally(() => {
					this.isLoadingAssegnaInMassaDataScadenzaSaldoEsitiDefinitivi = false;
				})
		}
	}
}
</script>